import { useContext } from 'react';
import { GlobalSearchContext } from '../context/GlobalSearchContext';

export function useGlobalSearchContext() {
  return useContext(GlobalSearchContext);
}
